import { useMemo } from 'react';
import { generatePath } from 'react-router-dom';

import { SHARING_ORIGIN } from '@sorare/core/src/config';
import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';

const generateUserGroupInviteLink = (
  inviteRoute: string,
  joinSecret: string,
  userSlug?: string
) => {
  let link =
    SHARING_ORIGIN +
    generatePath(inviteRoute, {
      leagueSlug: joinSecret,
    });
  if (userSlug) {
    link = `${link}?referrer=${userSlug}`;
  }
  return link;
};

export const useLeagueInviteLink = (
  inviteRoute: string,
  joinSecret: string
) => {
  const { currentUser } = useCurrentUserContext();
  const userSlug = currentUser?.slug;

  const inviteLink = useMemo(
    () => generateUserGroupInviteLink(inviteRoute, joinSecret, userSlug),
    [inviteRoute, joinSecret, userSlug]
  );

  return inviteLink;
};
